
import { useState } from "react";
import { Avatar, Button, Dialog, Tooltip } from "@mui/material";
import api from "../services/api";
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";
import MessageAlert from "../messages/messageAlert";
import BottonLeft from "./buttonLeft";

const tamanhoImage = 270;



function SimpleDialog(props) {
    const { onClose, open, submitEdit, setEdit, edit, Logo, openLoad, messageSuccess, messageError } = props;

    const handleClose = () => { onClose(false); }

    return (
        <Dialog open={open} onClose={handleClose} fullWidth disablePortal>
            <div className="tw-font-sans tw-leading-[1.5] tw-p-2.5 tw-text-center">

                {messageSuccess && <MessageAlert type={'success'} message={messageSuccess} />}
                {messageError && <MessageAlert type={'error'} message={messageError} />}

                <div className="tw-mb-2.5 tw-flex tw-justify-center tw-items-center">
                    <div>
                        {edit ?
                            <Avatar className="tw-w-[270px] tw-h-[270px] tw-rounded-[5px] tw-transition-opacity hover:tw-opacity-50" variant="square" src={URL.createObjectURL(edit)} title="Clique para carregar uma imagem" />
                            :
                            <Avatar className="tw-w-[270px] tw-h-[270px] tw-rounded-[5px]" variant="square" src={Logo} title="Clique para carregar uma imagem" />
                        }
                    </div>
                    <input accept="image/png, image/jpg, image/jpeg" type="file" name="foto" id="foto" className="tw-hidden" onChange={(e) => setEdit(e.target.files[0])} />
                </div>

                {edit ?
                    <BottonLeft
                        title={'Salvar'}
                        funcao={submitEdit}
                        disabled={openLoad}
                        load={openLoad}
                    >
                        <Button onClick={() => setEdit('')} color="error" >cancelar</Button>

                    </BottonLeft>
                    :
                    <Button autoFocus className="tw-mr-2" size="small" >
                        <label htmlFor="foto" className="tw-cursor-pointer tw-text-center"> Carregar imagem</label>
                    </Button>
                }

            </div>
        </Dialog>
    );
}

SimpleDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
};

export default function ImagemEdit({ data, openEditLogo, setOpenEditLogo, url, local }) {
    const [logo, setLogo] = useState(data?.logo)
    const [edit, setEdit] = useState('')
    const [openLoad, setOpenLoad] = useState(false)
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const user = useSelector(state => state.account.user);

    const handleClose = () => {
        setOpenEditLogo && setOpenEditLogo(false);
        setEdit('')
    };

    const submitEdit = async () => {
        setOpenLoad(true)
        setMessageSuccess('')
        setMessageError('')

        const formData = new FormData();
        formData.append('logo', edit);
        formData.append(local, data._id);
        formData.append('userId', user?._id ?? '');

        await api.patch(url, formData)
            .then(res => {
                // setOpenEditLogo(false);
                setOpenLoad(false)
                local === 'estabelecimentoId' && setLogo(res.data.estabelecimento.logo)
                local === 'empresaId' && setLogo(res.data.empresa.logo)
                setEdit('')
                setMessageSuccess('Sucesso.')
                // console.log(res)

            }).catch(err => {
                // console.log(err)
                setOpenLoad(false)
                setMessageError('Não foi possivel realizar esta ação.')
            })
    }

    return (
        <>
            <SimpleDialog
                Logo={logo}
                open={openEditLogo}
                openLoad={openLoad}
                onClose={handleClose}
                submitEdit={submitEdit}
                edit={edit}
                setEdit={setEdit}
                messageSuccess={messageSuccess}
                messageError={messageError}
            />

            {/* user?.isAdmin &&  */}
            <Tooltip title={data?.nome}>
                <div onClick={() => setOpenEditLogo && setOpenEditLogo(true)} className="tw-mb-2.5 tw-flex tw-justify-center">
                    {edit
                        ?
                        <Avatar alt={data?.nome} className="tw-w-[270px] tw-h-[270px] tw-rounded-[5px] tw-transition-opacity hover:tw-opacity-50" variant="square" src={URL.createObjectURL(edit)} title="Clique para carregar uma imagem" />
                        :
                            <Avatar alt={data?.nome} className="tw-w-[270px] tw-h-[270px] tw-rounded-[5px]" variant="square" src={logo} title={user?.tipo === 'Admin' ? "Clique para carregar uma imagem" : ''} />
                        }
                </div>
            </Tooltip>
        </>
    )
}